import { ThemeSelectors } from "@at/design-system-foundation";
import styled, { css } from "styled-components";

const navButtonGlobal = css`
  position: absolute;
  z-index: 100;
  display: flex;
  align-items: center;
  height: 100%;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
`;

export const BannerItem = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: block;
  transition: all 0.5s linear;
  opacity: 0;

  &.activeSlide {
    transform: translateX(0);
    opacity: 1;
  }
  &.lastSlide {
    transform: translateX(-100%);
  }
  &.nextSlide {
    transform: translateX(100%);
  }
`;

export const BannerItemContentWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const NavPrevButton = styled.button`
  ${navButtonGlobal}
  left: 0;
  margin-left: ${({ theme }) => ThemeSelectors.getGroupFourSpacing(theme)};
`;

export const NavNextButton = styled.button`
  ${navButtonGlobal}
  right: 0;
  margin-right: ${({ theme }) => ThemeSelectors.getGroupFourSpacing(theme)};
`;
